var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.344 5.30167e-08L1.65459 5.30167e-08C0.740662 0.000457817 -0.000228829 0.741806 5.30167e-08 1.65596L5.30167e-08 28.3454C0.000457817 29.2593 0.741806 30.0002 1.65596 30H28.344C29.2584 30.0002 29.9998 29.2591 30 28.3447C30 28.3445 30 28.3443 30 28.344V1.65459C29.9995 0.740662 29.2582 -0.000228829 28.344 5.30167e-08Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7334 30.0005V18.399H24.6445L25.2305 13.858H20.7334V10.9658C20.7334 9.65408 21.0975 8.7603 22.9785 8.7603H25.3623V4.70978C24.9476 4.65462 23.5246 4.53125 21.8689 4.53125C18.4118 4.53125 16.0459 6.64062 16.0459 10.5161V13.858H12.1494V18.399H16.0459V30.0005H20.7334Z",
    fill: "#3377EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3d00976f3b0d342e6371fce6aa8e12c1.svg";
export { ForwardRef as ReactComponent };